import React from "react";
import { Tooltip } from "react-tooltip";
import { FaQuestionCircle } from "react-icons/fa";
import { InvoiceDetails, tooltipContent } from "../../../../../locales/en";
import { DEFAULT_REPAYMENT_DATE_EXTENSION_DAYS } from "../../../../../utils/constants/appConstants";
export const COLUMNS = [
  {
    Header: "Invoice Number",
    Footer: "Invoice Number",
    accessor: "invoiceNumber"
  },
  {
    Header: (
      <>
        <span id="repay-date-tooltip">
          {InvoiceDetails.paymentSection.paymentModal.rePaymentDate}
        </span>
        <span
          data-tooltip-id="demoAccColumn"
          className="ms-2"
          data-tooltip-content={`${tooltipContent.content1}${DEFAULT_REPAYMENT_DATE_EXTENSION_DAYS}${tooltipContent.content1End}`}
        >
          <FaQuestionCircle />
        </span>
        <Tooltip id="demoAccColumn" className="report_tooltip" />
      </>
    ),
    Footer: "Repayment Date",
    accessor: "dueDate"
  },
  {
    Header: "Advance",
    Footer: "Advance",
    accessor: "advanceAmount",
    Cell: ({ value }) => {
      const formattedValue =
        value !== undefined && value !== null && value !== ""
          ? value.toFixed(2)
          : "0.00";
      return `$${formattedValue}`;
    }
  },
  {
    Header: "Fee",
    Footer: "Fee",
    accessor: "feeAmount",
    Cell: ({ value }) => {
      const formattedValue =
        value !== undefined && value !== null && value !== ""
          ? value.toFixed(2)
          : "0.00";
      return `$${formattedValue}`;
    }
  }
];
